// OSM karolarından statik harita görüntüsü üretir (PDF çıktısı için) — CORS'lu tile.openstreetmap.org
const TILE = 256;
const lon2x = (lon, z) => ((lon + 180) / 360) * 2 ** z;
const lat2y = (lat, z) => {
  const r = (lat * Math.PI) / 180;
  return ((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2) * 2 ** z;
};

const loadTile = (z, x, y) => new Promise((resolve) => {
  const n = 2 ** z;
  if (y < 0 || y >= n) { resolve(null); return; }
  const img = new Image();
  img.crossOrigin = 'anonymous';
  const t = setTimeout(() => resolve(null), 8000);
  img.onload = () => { clearTimeout(t); resolve(img); };
  img.onerror = () => { clearTimeout(t); resolve(null); };
  img.src = `https://tile.openstreetmap.org/${z}/${((x % n) + n) % n}/${y}.png`;
});

function drawPin(g, x, y) {
  g.save();
  g.shadowColor = 'rgba(0,0,0,0.35)'; g.shadowBlur = 6; g.shadowOffsetY = 2;
  g.fillStyle = '#dc2626';
  g.beginPath();
  g.moveTo(x, y);
  g.bezierCurveTo(x - 22, y - 26, x - 16, y - 46, x, y - 46);
  g.bezierCurveTo(x + 16, y - 46, x + 22, y - 26, x, y);
  g.fill();
  g.shadowColor = 'transparent';
  g.fillStyle = '#fff';
  g.beginPath(); g.arc(x, y - 31, 6.5, 0, Math.PI * 2); g.fill();
  g.restore();
}

/** Döner: { dataUrl, ok } — ok=false ise hiç karo yüklenemedi */
export async function buildStaticMap({ lat, lon, zoom = 15, width = 1000, height = 460 }) {
  const canvas = document.createElement('canvas');
  canvas.width = width; canvas.height = height;
  const g = canvas.getContext('2d');
  g.fillStyle = '#e5e7eb'; g.fillRect(0, 0, width, height);
  const cx = lon2x(lon, zoom) * TILE; const cy = lat2y(lat, zoom) * TILE;
  const left = cx - width / 2; const top = cy - height / 2;
  const jobs = [];
  let loaded = 0;
  for (let x = Math.floor(left / TILE); x <= Math.floor((left + width) / TILE); x++) {
    for (let y = Math.floor(top / TILE); y <= Math.floor((top + height) / TILE); y++) {
      jobs.push(loadTile(zoom, x, y).then((img) => {
        if (!img) return;
        loaded += 1;
        g.drawImage(img, Math.round(x * TILE - left), Math.round(y * TILE - top));
      }));
    }
  }
  await Promise.all(jobs);
  if (!loaded) return { dataUrl: null, ok: false };
  drawPin(g, width / 2, height / 2);
  const attr = '© OpenStreetMap katkıda bulunanlar';
  g.font = '14px sans-serif';
  const tw = g.measureText(attr).width + 12;
  g.fillStyle = 'rgba(255,255,255,0.85)'; g.fillRect(width - tw, height - 22, tw, 22);
  g.fillStyle = '#374151'; g.fillText(attr, width - tw + 6, height - 7);
  return { dataUrl: canvas.toDataURL('image/jpeg', 0.85), ok: true };
}
